import { CHECKOUT_TYPE } from "../constants.checkout";
import { TCheckoutType } from "../types.checkout";

export function isSupportedCheckoutType(
  checkoutTypeParam: string | null,
): checkoutTypeParam is TCheckoutType {
  return (
    checkoutTypeParam === CHECKOUT_TYPE.PURCHASE ||
    checkoutTypeParam === CHECKOUT_TYPE.MANAGE ||
    checkoutTypeParam === CHECKOUT_TYPE.MIGRATION
  );
}
